import { useQueryClient } from "@tanstack/react-query";
import { Modal } from "components";
import { Button } from "expano-components";
import useCreate from "hooks/useCreate";

const CreateProductsFromCsvModal = ({
  data,
  attributes,
  is_file_correct,
  handleClose,
}) => {
  const query = useQueryClient();

  const { is_creating, create } = useCreate({
    path: "/products/bulk_import",
    onSuccess: () => {
      query.refetchQueries(["products"]);
      handleClose();
    },
  });

  return (
    <Modal
      handleClose={handleClose}
      header={{
        title: "Dodaj produkty",
      }}
      size="full"
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            text="Dodaj"
            disabled={is_creating || !is_file_correct}
            onClick={() => create({ products_attributes: attributes })}
          />
        </>
      }
    >
      <table className="table">
        <thead className="table__header table-head">
          <tr>
            <th>Ean</th>
            <th>SKU</th>
            <th>Kod producenta</th>
            <th>Nazwa</th>
            <th>SKU prod. grup.</th>
            <th>Synchronizacja</th>
            <th>Bundle</th>
            <th>Wirtualny</th>
          </tr>
        </thead>
        <tbody className="table__body table-body">
          {data.map(
            ({
              sku,
              ean,
              name,
              producer_code,
              product_group,
              has_infinite_sales_stock,
              is_bundle,
              product_components_as_bundle_attributes,
              is_virtual,
              product_substitutes_as_virtual_attributes,
            }) => (
              <tr key={sku}>
                <td className="p-r-5">
                  {ean || <span className="text-danger">Brak ean</span>}
                </td>
                <td className="p-r-5">
                  {sku || <span className="text-danger">Brak sku</span>}
                </td>
                <td className="p-r-5">
                  {producer_code || (
                    <span className="text-danger">Brak kodu producenta</span>
                  )}
                </td>
                <td className="p-r-5">
                  {name || <span className="text-danger">Brak nazwy</span>}
                </td>
                <td className="p-r-5">
                  {product_group?.id ? (
                    product_group?.sku
                  ) : (
                    <span className="text-danger">Brak produktu grupowego</span>
                  )}
                </td>
                <td>{has_infinite_sales_stock ? "Nie" : "Tak"}</td>
                <td>
                  {is_bundle ? (
                    <ul>
                      {product_components_as_bundle_attributes?.map(
                        ({ quantity, sku }) => (
                          <li>
                            {sku ? (
                              `${quantity} szt. x ${sku}`
                            ) : (
                              <span className="text-danger">
                                Nie znaleziono komponentu
                              </span>
                            )}
                          </li>
                        ),
                      )}
                    </ul>
                  ) : (
                    "Nie"
                  )}
                </td>
                <td>
                  {is_virtual ? (
                    <ul>
                      {product_substitutes_as_virtual_attributes?.map(
                        ({ sku }) => (
                          <li>
                            {sku ? (
                              sku
                            ) : (
                              <span className="text-danger">
                                Nie znaleziono komponentu
                              </span>
                            )}
                          </li>
                        ),
                      )}
                    </ul>
                  ) : (
                    "Nie"
                  )}
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    </Modal>
  );
};

export default CreateProductsFromCsvModal;
